import * as React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { useNavigate, useParams} from 'react-router-dom'
import firebase, {auth} from '../../firebase/firebase'
import Box from "@mui/material/Box";
import {AuthUserContext} from "../../providers/AuthProvider";
import ScrollToTop from '../../utils/scrollTop';
import PostActivity from "../../helpers/post-activity";


export default function ListServiceDetailsView(){
  const {  profile} = React.useContext(AuthUserContext);
  const navigator = useNavigate()
  const {serviceId} = useParams();
  const [getService, setService] = React.useState();
  const downloadURL = (url) => new Promise(((resolve, reject) => {
    const storageRef = firebase.storage().ref();

    const mediaRef = storageRef.child(url);

// Get the download URL
    mediaRef.getDownloadURL()
      .then((url) => {
        resolve(url);
        // setImageUrl(url)
        // setLoading(false)
        // Insert url into an <img> tag to "download"
      })
      .catch((error) => {
        reject(error)
        // setLoading(false)

        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/object-not-found':
            // File doesn't exist
            break;
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
          case 'storage/canceled':
            // User canceled the upload
            break;

          // ...

          case 'storage/unknown':
            // Unknown error occurred, inspect the server response
            break;
        }
      });
  }))

  const sendOffer = async () => {
    try {
      const chatRef = firebase.firestore().collection('rooms');
      const messageRef = firebase.firestore().collection('messages');

      const getChat = await chatRef.where('participates', 'array-contains', getService.uid).get()
      let isAlready = false;
      let chatId;
      let chat
      if (getChat.size > 0) {
        getChat.docs.forEach((d) => {
          const id = d.data().participates.find((d) => d === profile?.uid)
          if (id) {
            isAlready = true
            chatId = d.id
          }
        })
      }
      if (!isAlready) {
        chat = await chatRef.add({
          createdBy: profile.uid,
          participates: [profile.uid, getService.uid],
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          projectTitle: profile?.name,
          adminCreated: true
        })
         await messageRef.add(
            {
              text: `Please go ahead and upload your signed contract`,
              type: 'created-message',
              sender: profile?.uid,
              receiver: getService.uid,
              createdAt:firebase.firestore.FieldValue.serverTimestamp(),
              roomId: isAlready ? chatId :chat?.id,
              read:false,
              status: 'send'
            }
        )
      } else{
        chatRef.doc(chatId).update({
          // lastMsg: {
          //   status: 'seen',
          //   text: `Please go ahead and upload your signed contract`,
          //   type: 'text'
          // },
          updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        }).then()
      }


      PostActivity({
        text: `You sent a request to "${getService?.name || ''}"`,
        uid: profile.uid,
        createdBy:profile?.uid
      }).then()
      navigator('/creator/chat');
    } catch (e) {

    }
  }
  React.useEffect(() => {
    if (serviceId) {
      const serviceRef = firebase.firestore().collection('services').doc(serviceId);
      serviceRef.get().then(async (doc) => {
        const service = {id: doc.id, ...doc.data()}
        if (service.avatar && service.avatar !== '') {
          const avatar = await downloadURL(service.avatar);
          setService({...service, avatar})
        } else{
          setService(service);
        }
      })


    }
  } , [serviceId])


  return(
    <React.Fragment>
      <ScrollToTop/>

      <Container maxWidth="lg" sx={{textAlign:'left' , mt: 5}}>
        {
          getService &&  <Stack
            direction={'row'}
            spacing={5}
            justifyContent="flex-start"
            alignItems="flex-start">
            <Stack sx={{width:255}} direction={'column'} spacing={3} justifyContent="flex-start"
                   alignItems="center">
              {getService.avatar && getService.avatar !== '' &&
                <img src={getService.avatar} style={{width:255, height:310, objectFit:'cover'}} alt={getService.name}/>}
                <Typography variant={'h4'} color={'primary'} noWrap={true} sx={{maxWidth:250, textTransform:'capitalize'}}>{getService?.name}</Typography>
            </Stack>
            <Stack sx={{flex:1}} direction={'column'} spacing={5} justifyContent="flex-start"
                   alignItems="flex-start">
              <Typography Typography variant={'h5'}  color={'primary'}  sx={{textTransform:'Uppercase', borderBottom: '1px solid', width: '100%'}}>
                BIOGRAPHY
              </Typography>
              <Typography Typography variant={'body1'} sx={{lineHeight: 1.7}}  color={'grey'}>
                {getService?.biography}
              </Typography>
              <Typography Typography variant={'h5'}  color={'primary'}  sx={{textTransform:'Uppercase', borderBottom: '1px solid', width: '100%'}}>
                About
              </Typography>

              { (getService?.type.length > 0) ?
              <Stack direction={'row'} >
                  <Typography  sx={{width: "200px"}} color={'primary'} variant={'body1'}>
                    Type of artist
                  </Typography>  <></>
                <Typography  color={'grey'} variant={'body1'} sx={{width:"600px"}}>
                  {getService?.type && getService?.type.length > 0 &&
                    getService?.type.map((t) => (`${t}${t !== getService?.type[getService?.type.length - 1] ? '  , ' : ''}`))

                  }
                </Typography>
              </Stack> : <></>
              }

              {(getService?.gender) ?
                <Stack direction={'row'}  >
                  <Typography sx={{width:"200px"}}  color={'primary'} variant={'body1'}>
                    Gender
                  </Typography>
                  <Typography   color={'grey'} variant={'body1'} >
                    {getService?.gender
                    }
                  </Typography>
                </Stack>: <></>
              }

              {(getService?.location) ?
                <Stack direction={'row'}  >
                  <Typography  sx={{width:"200px"}}  color={'primary'} variant={'body1'}>
                    Location
                  </Typography>
                  <Typography  color={'grey'} variant={'body1'} >
                    {getService?.location
                    }
                  </Typography>
                </Stack> : <></>
              }

              {(getService?.language.length > 0) ?
                <Stack direction={'row'}  >
                  <Typography sx={{width:"200px"}} color={'primary'} variant={'body1'}>
                    Language
                  </Typography>
                  <Typography  color={'grey'} variant={'body1'}>
                    {getService?.language && getService?.language.length > 0 &&
                      getService?.language.map((t) => (`${t}${t !== getService?.language[getService?.language.length - 1] ? ', ' : ''}`))
                    }
                  </Typography>
                </Stack> : <></>
              }

              { (getService?.skills.length > 0) ?
              <Typography Typography variant={'h5'}  color={'primary'}  sx={{textTransform:'Uppercase', borderBottom: '1px solid', width: '100%'}}>
                Skills
              </Typography> : <></>
              }
              <Stack direction={'row'} spacing={2} >
                {getService?.skills && getService?.skills.length > 0 &&
                  getService?.skills.map((t) => (<Box sx={{py: 1, px: 3, borderRadius: '30px', backgroundColor: '#D1E1FF'}}>
                    {t}
                  </Box>))
                }

              </Stack>

              { (getService?.linkedin || getService?.imdb || getService?.portfolio || getService?.other) ?
                <Typography Typography variant={'h5'}  color={'primary'}  sx={{textTransform:'Uppercase', borderBottom: '1px solid', width: '100%'}}>
                  Work
                </Typography> : <></>
              }

              {(getService?.linkedin) ?
                <Stack direction={'row'} spacing={5} >
                  <Typography  sx={{width: 150}} color={'primary'} variant={'body1'}>
                    LinkedIn
                  </Typography>
                  <Typography  color={'grey'} variant={'body1'}>
                    {getService?.linkedin}
                  </Typography>
                </Stack> : <></>
              }

              {(getService?.imdb) ?
                <Stack direction={'row'} spacing={5} >
                  <Typography  sx={{width: 150}} color={'primary'} variant={'body1'}>
                    IMDB
                  </Typography>
                  <Typography  color={'grey'} variant={'body1'}>
                    {getService?.imdb}
                  </Typography>
                </Stack> : <></>
              }

              {(getService?.portfolio) ?
                <Stack direction={'row'} spacing={5} >
                  <Typography  sx={{width: 150}} color={'primary'} variant={'body1'}>
                    Portfolio
                  </Typography>
                  <Typography  color={'grey'} variant={'body1'}>
                    {getService?.portfolio}
                  </Typography>
                </Stack> : <></>
              }

              {(getService?.other) ?
                <Stack direction={'row'} spacing={5} >
                  <Typography  sx={{width: 150}} color={'primary'} variant={'body1'}>
                    Others
                  </Typography>
                  <Typography  color={'grey'} variant={'body1'}>
                    {getService?.other}
                  </Typography>
                </Stack> : <></>
              }

              {profile?.userType === 'creator' && <Stack direction={'row'} spacing={5} justifyContent="center"
                                                         alignItems="center" sx={{width: '100%', pr: 29 }}>
                <Button variant={'contained'} sx={{px: 3}} color={'primary'} onClick={sendOffer}>Send offer</Button>
              </Stack>}
              <Stack/>
              <Stack/>
              <Stack/>


            </Stack>

          </Stack>
        }

      </Container>

    </React.Fragment>

  )


}